(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cp-why-reasons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cp-why-image-carousel')) {
    customElements.define('cp-why-image-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-why-image-track]');
        this.slides = this.querySelectorAll('[data-why-image-slide]');
        this.isAutoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.autoplaySpeed, 10) || 4) * 1000;
        this.timer = null;

        this.querySelector('[data-why-image-previous]')?.addEventListener('click', () => {
          this.move(-1);
          this.resetAutoplay();
        });
        this.querySelector('[data-why-image-next]')?.addEventListener('click', () => {
          this.move(1);
          this.resetAutoplay();
        });

        if (this.isAutoplay && this.slides.length > 1) {
          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }
      }

      move(direction) {
        if (!this.track || this.slides.length < 2) return;
        const current = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const next = (current + direction + this.slides.length) % this.slides.length;
        
        // 当从最后一张切回第一张（即 current 为最后一张且方向向右）时，使用 instant 瞬间跳转，避免倒带感
        const isLoopingBack = current === this.slides.length - 1 && next === 0;
        const behavior = isLoopingBack ? 'instant' : 'smooth';

        this.track.scrollTo({ left: next * this.track.clientWidth, behavior });
      }

      startAutoplay() {
        if (this.timer || !this.isAutoplay) return;
        this.timer = setInterval(() => this.move(1), this.speed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      resetAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
